import React, { useState } from "react";
import { FiChevronDown } from "react-icons/fi";
import HeroSection from "../../components/UserComponents/heroSection";
import PageHeader from "../../components/common/PageHeader";

const faqs = [
  {
    q: "How does Toucan work?",
    a: "Toucan connects guests with curated local experiences hosted by independent creators. Guests browse experiences, book through the platform, attend the experience, and leave a review. Toucan manages booking, payments, and communication.",
  },
  {
    q: "How do I book an experience?",
    a: "Select an experience, choose a date and time, and complete checkout. A confirmation email is sent immediately after booking.",
  },
  {
    q: "Will I receive a reminder before my experience?",
    a: "Yes. Toucan sends an automated reminder approximately 24 hours before your experience.",
  },
  {
    q: "What is your cancellation policy?",
    a: "Guests may cancel for a full refund up to 7 days before the experience. Cancellations within 7 days are non-refundable.",
  },
  {
    q: "Can I get a refund if I don’t like the experience?",
    a: "No. Toucan does not issue refunds after an experience has occurred. Personal preference or unmet expectations are not grounds for a refund.",
  },
  {
    q: "How are payments handled?",
    a: "Guests pay at booking. Toucan securely processes and holds funds until the experience is completed.",
  },
  {
    q: "When are hosts paid?",
    a: "Hosts are paid 24–72 hours after the experience has been completed.",
  },
  {
    q: "How do I contact support?",
    a: "Reply to your booking emails or use the Support page on the website.",
  },
  {
    q: "Can I message the host directly?",
    a: "At launch, Toucan does not offer direct guest-to-host messaging.",
  },
  {
    q: "What is the First Flight Fund?",
    a: "The First Flight Fund supports creators with strong ideas and real potential to succeed.",
  },
];

const FAQItem = ({ item, isOpen, onToggle }) => (
  <div className="border-b border-gray-200 py-4">
    <button
      onClick={onToggle}
      className="w-full flex items-center justify-between text-left"
    >
      <h3 className="text-base font-medium text-gray-900">{item.q}</h3>
      <FiChevronDown
        className={`transition-transform ${isOpen ? "rotate-180" : ""}`}
      />
    </button>

    {isOpen && (
      <p className="mt-3 text-sm text-gray-600 leading-relaxed">{item.a}</p>
    )}
  </div>
);

export default function FAQs() {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <div>
      {/* HERO (no search) */}
      <HeroSection
        title="Frequently Asked Questions"
        description="Everything you need to know about booking and hosting experiences on Toucan."
        showSearchBar={false}
      />

      <div className="max-w-4xl mx-auto px-4 py-10">
        <PageHeader title="FAQs" />

        <div className="mt-6">
          {faqs.map((item, index) => (
            <FAQItem
              key={index}
              item={item}
              isOpen={openIndex === index}
              onToggle={() => setOpenIndex(openIndex === index ? null : index)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
